export const QUERY_OUTPUT_TYPES = {
  SELECTED_COLUMN: 'SELECTED_COLUMN',
  FILTERED_COLUMN: 'FILTERED_COLUMN',
  SELECTED_RECORD: 'SELECTED_RECORD',
  FILTERED_RECORD: 'FILTERED_RECORD',
  COUNT_COLUMN: 'COUNT_COLUMN',
};
